import React from 'react';

// import {
//   ActivityIndicator,
// } from 'react-native';

import {
  Colors,
} from '../../../shared/constants';

import {
  ButtonActionContainer,
  IconLeftView,
  IconRightView,
  ButtonActionText,
  ButtonChildrenAction,
} from './styled';



export interface IProps {
  type?: 'button' | 'submit' | 'reset' | undefined;
  bold?: boolean;
  scale?: any;

  disabled?: boolean;
  loading?: boolean;

  width?: number | string;
  height?: number;

  backgroundColor?: string;
  color?: string;

  text: string;
  iconLeft?: any;
  iconRight?: any;

  onPress?: any;
  children?: any;
}



const ButtonChoose: React.FC<IProps> = (props: IProps) => {
  const className = { ...props } as any;


  const backgroundColor = props.backgroundColor || Colors.primary;
  const color = props.color || Colors.white;



  return (

    <ButtonActionContainer
      className={className?.className}

      type={props.type}
      scale={props.scale}

      disabled={props.disabled}

      color={color}
      backgroundColor={Colors.transparent}
      hoverColor={props.disabled ? Colors.disabled : backgroundColor}

      onClick={() => {
        if (props.onPress) {
          props.onPress();
        }
      }}>

      {props.iconLeft && !props.loading && (
        <IconLeftView>
          {props.iconLeft}
        </IconLeftView>
      )}



      <ButtonChildrenAction>
        {props.text && !props.loading && (
          <ButtonActionText
            bold={props.bold}
            color={color}>
            {props.text}
          </ButtonActionText>
        )}

        {/*
        {props.loading && (
          <ActivityIndicator
            color={'white'}
            size={'small'}
          />
        )}
        */}
      </ButtonChildrenAction>



      {props.iconRight && (
        <IconRightView>
          {props.iconRight}
        </IconRightView>
      )}

    </ButtonActionContainer>

  );
};



ButtonChoose.defaultProps = {
  type: 'button',
  disabled: false,
  loading: false,
};



export default ButtonChoose;
